function normalizeId(value) {
    if (value === undefined || value === null) return ''
    return String(value)
}

function getChannelId(channel) {
    return normalizeId(
        channel?.connectorId ??
            channel?.id ??
            channel?.channelId ??
            channel?.maxBusinessChannelId
    )
}

function getConnectorId(connector) {
    return normalizeId(connector?.connectorId ?? connector?.id)
}

function getConnectorName(connector) {
    return (
        connector?.name ||
        connector?.title ||
        connector?.displayName ||
        connector?.botName ||
        connector?.settings?.name ||
        connector?.data?.name ||
        ''
    )
}

function getChannelName(channel, connector, index) {
    return (
        channel?.name ||
        channel?.title ||
        channel?.displayName ||
        channel?.channelName ||
        channel?.botName ||
        channel?.botUsername ||
        channel?.username ||
        getConnectorName(connector) ||
        `MAX Business${index > 0 ? ` ${index + 1}` : ''}`
    )
}

export function mapMaxBusinessChannelsToSelectOptions(channels = [], connectors = []) {
    const list = Array.isArray(channels) ? channels : []
    const connectorList = Array.isArray(connectors) ? connectors : []

    return list
        .map((channel, index) => {
            const id = getChannelId(channel)
            if (!id) return null

            const connector = connectorList.find((item) => getConnectorId(item) === id)
            return {
                ...channel,
                id,
                name: getChannelName(channel, connector, index),
            }
        })
        .filter(Boolean)
}
